const ShipNotesReducer = (state = {}, action) => {
    switch (action.type) {
        case "ShowNoteSidePan":
            return Object.assign({}, state, {
                ShowNoteSidePan: action.data,
            });
            break;
        case "getShipNotesList":
            return Object.assign({}, state, {
                ShipNoteList: action.data,
            });
            break;
        case "getShipNotesListFailure":
            return Object.assign({}, state, {
                ShipNoteList: action.data,
            });
            break;
        case "AddNoteSuccess":
            return Object.assign({}, state, {
                AddNoteData: action.data,
            });
            break;
        case "AddNoteFailure":
            return Object.assign({}, state, {
                AddNoteData: action.data,
            });
            break;
        case "UpdateNoteSuccess":
            return Object.assign({}, state, {
                UpdateNoteData: action.data,
            });
            break;
        case "UpdateNoteFailure":
            return Object.assign({}, state, {
                UpdateNoteData: action.data,
            });
            break;
        case "deleteNoteSuccess":
            return Object.assign({}, state, {
                DeleteNoteData: action.data,
            });
            break;
        case "deleteNoteFailure":
            return Object.assign({}, state, {
                DeleteNoteData: action.data,
            });
            break;
        case "ShipInfo":
            return Object.assign({}, state, {
                ShipInfo: action.data,
            });
            break;
        case "NoteDetails":
            return Object.assign({}, state, {
                NoteDetail: action.data,
            });
            break;
        case "NoteDetailFailure":
            return Object.assign({}, state, {
                NoteDetail: action.data,
            });
            break;
        default: {
            return state;
        }
    }
};
export default ShipNotesReducer;
